<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'TunnelConfigurationList' }">
                <i class="fas fa-chevron-left"></i>
              </router-link>
              Tunnel Configurations
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Tunnel Configurations</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="TunnelConfiguration">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div v-if="organizationId == 1 || is_copy" class="form-group required">
                    <label class="control-label">Audra</label>
                    <input
                      v-if="is_edit"
                      type="text"
                      v-model="pre.audraName[value.accountId]"
                      id="accountId"
                      class="form-control accountId"
                      name="accountId"
                      readonly
                    />
                    <multiselect
                      v-else
                      v-model="value.accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="(opt) => pre.audraName[opt]"
                      placeholder="Select Audra"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="Audra"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('Audra')">
                      {{ errors.first("Audra") }}
                    </div>
                  </div>

                  <!-- <div class="form-group">
                    <label class="control-label">Type</label>
                    <multiselect
                      v-model="value.interface_type"
                      :options="Object.keys(pre.interfaceTypes)"
                      :custom-label="opt => pre.interfaceTypes[opt]"
                      :searchable="false"
                      :multiple="false"
                      id="interface_type"
                      v-bind:class="{
                        'has-error': errors.has('interface_type')
                      }"
                      v-validate="'required'"
                      name="interface_type"
                      :allow-empty="false"
                      deselect-label=""
                      @input="$forceUpdate()"
                    >
                    </multiselect>
                  </div> -->

                  <div class="form-group">
                    <label class="control-label">Type</label>
                    <div class="d-flex">
                      <label
                        class="radio mr-3"
                        v-for="(interface_type, index) in ['GRE', 'VTI', 'SITETOSITE']"
                        :key="index"
                      >
                        <input
                          type="radio"
                          :value="interface_type"
                          v-model="value.interface_type"
                          name="interface_type"
                          id="interface_type"
                          :disabled="is_edit"
                          @click="updateTunnelType(interface_type)"
                        />
                        <span class="radio-mark"></span>
                        {{ interface_type.toUpperCase() }}
                      </label>
                    </div>
                  </div>

                  <div>
                    <h4 class="card-common-title p-0 my-3">
                      {{
                        value.interface_type === "SITETOSITE"
                          ? "Phase 1"
                          : value.interface_type
                      }}
                    </h4>
                  </div>

                  <div v-if="value.interface_type === 'GRE'">
                    <div v-if="is_edit" class="form-group">
                      <label class="control-label">Status</label>
                      <!-- <multiselect
                        v-model="value.tunnel_status"
                        :options="Object.keys(pre.tunnelStatus)"
                        :custom-label="(opt) => pre.tunnelStatus[opt]"
                        :searchable="false"
                        :multiple="false"
                        id="tunnel_status"
                        v-bind:class="{
                          'has-error': errors.has('tunnel_status'),
                        }"
                        v-validate="'required'"
                        name="tunnel_status"
                      >
                      </multiselect> -->
                      <div class="d-flex">
                        <label
                          class="radio mr-3"
                          v-for="(tunnel_status, index) in Object.keys(pre.tunnelStatus)"
                          :key="index"
                        >
                          <input
                            type="radio"
                            :value="tunnel_status"
                            v-model="value.tunnel_status"
                            name="tunnel_status"
                            id="tunnel_status"
                            v-validate="'required'"
                          />
                          <span class="radio-mark"></span
                          >{{ tunnel_status.toUpperCase() }}
                        </label>
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Name</label>
                      <input
                        type="text"
                        id="tunnel_name"
                        name="tunnel_name"
                        v-bind:class="{
                          'has-error': errors.has('tunnel_name'),
                        }"
                        v-model="value.tunnel_name"
                        class="form-control tunnel_name"
                        placeholder="Name"
                        @keyup="setErrors($event)"
                        :readonly="is_edit"
                      />
                      <div class="help text-danger">
                        {{ GREErrors["tunnel_name"] }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Description</label>
                      <input
                        type="text"
                        id="description"
                        name="description"
                        v-bind:class="{
                          'has-error': errors.has('description'),
                        }"
                        v-model="value.description"
                        class="form-control description"
                        placeholder="Description"
                        @keyup="setErrors($event)"
                        :readonly="is_edit"
                      />
                      <div class="help text-danger">
                        {{ GREErrors["description"] }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Local</label>
                      <input
                        type="text"
                        id="local_ip"
                        name="local_ip"
                        v-bind:class="{
                          'has-error': errors.has('local_ip'),
                        }"
                        v-model="value.local_ip"
                        class="form-control local_ip"
                        placeholder="Example : 192.168.20.1"
                        @keyup="setErrors($event)"
                      />
                      <div class="help text-danger">
                        {{ GREErrors["local_ip"] }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Remote</label>
                      <input
                        type="text"
                        id="remote_ip"
                        name="remote_ip"
                        v-bind:class="{
                          'has-error': errors.has('remote_ip'),
                        }"
                        v-model="value.remote_ip"
                        class="form-control remote_ip"
                        placeholder="Example : 192.168.30.1"
                        @keyup="setErrors($event)"
                      />
                      <div class="help text-danger">
                        {{ GREErrors["remote_ip"] }}
                      </div>
                    </div>
                    <div class="form-group required">
                      <label class="control-label">Tunnel IP</label>
                      <input
                        type="text"
                        id="tunnel_ip"
                        name="tunnel_ip"
                        v-bind:class="{
                          'has-error': errors.has('tunnel_ip'),
                        }"
                        v-model="value.tunnel_ip"
                        class="form-control tunnel_ip"
                        placeholder="Example : 192.168.20.0/24"
                        @keyup="setErrors($event)"
                      />
                      <div class="help text-danger">
                        {{ GREErrors["tunnel_ip"] }}
                      </div>
                    </div>
                    <div class="form-group required">
                      <label class="control-label">Remote Tunnel IP</label>
                      <input
                        type="text"
                        id="remote_tunnel_ip"
                        name="remote_tunnel_ip"
                        v-bind:class="{
                          'has-error': errors.has('remote_tunnel_ip'),
                        }"
                        v-model="value.remote_tunnel_ip"
                        class="form-control remote_tunnel_ip"
                        placeholder="Example : Example : 192.168.20.1"
                        @keyup="setErrors($event)"
                      />
                      <div class="help text-danger">
                        {{ GREErrors["remote_tunnel_ip"] }}
                      </div>
                    </div>
                  </div>

                  <div v-else-if="value.interface_type === 'VTI'">
                    <div v-if="is_edit" class="form-group">
                      <label class="control-label">Status</label>
                      <multiselect
                        v-model="value.tunnel_status"
                        :options="Object.keys(pre.tunnelStatus)"
                        :custom-label="(opt) => pre.tunnelStatus[opt]"
                        :searchable="false"
                        :multiple="false"
                        id="tunnel_status"
                        v-bind:class="{
                          'has-error': errors.has('tunnel_status'),
                        }"
                        v-validate="'required'"
                        name="tunnel_status"
                      >
                      </multiselect>
                    </div>
                    <div class="form-group required">
                      <label class="control-label">Name</label>
                      <input
                        type="text"
                        id="vti_name"
                        name="vti_name"
                        v-model="value.vti_name"
                        v-bind:class="{
                          'has-error': errors.has('vti_name'),
                        }"
                        class="form-control vti_name"
                        placeholder="Name"
                        @keyup="setErrors($event)"
                        :readonly="is_edit"
                      />
                      <div class="help text-danger">
                        {{ VTIErrors["vti_name"] }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">VTI Description</label>
                      <input
                        type="text"
                        id="vti_description"
                        name="vti_description"
                        v-model="value.vti_description"
                        v-bind:class="{
                          'has-error': errors.has('vti_description'),
                        }"
                        class="form-control vti_description"
                        placeholder="Description"
                        @keyup="setErrors($event)"
                        :readonly="is_edit"
                      />
                      <div class="help text-danger">
                        {{ VTIErrors["vti_description"] }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Local</label>
                      <input
                        type="text"
                        id="vti_local_ip"
                        name="vti_local_ip"
                        v-bind:class="{
                          'has-error': errors.has('vti_local_ip'),
                        }"
                        v-model="value.vti_local_ip"
                        class="form-control vti_local_ip"
                        placeholder="Example : 192.168.20.1"
                        @keyup="setErrors($event)"
                      />
                      <div class="help text-danger">
                        {{ VTIErrors["vti_local_ip"] }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Remote</label>
                      <input
                        type="text"
                        id="vti_remote_ip"
                        name="vti_remote_ip"
                        v-bind:class="{
                          'has-error': errors.has('vti_remote_ip'),
                        }"
                        v-model="value.vti_remote_ip"
                        class="form-control vti_remote_ip"
                        placeholder="Example : 192.168.20.1"
                        @keyup="setErrors($event)"
                      />
                      <div class="help text-danger">
                        {{ VTIErrors["vti_remote_ip"] }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Tunnel IP</label>
                      <input
                        type="text"
                        id="vti_tunnel_ip"
                        name="vti_tunnel_ip"
                        v-bind:class="{
                          'has-error': errors.has('vti_tunnel_ip'),
                        }"
                        v-model="value.vti_tunnel_ip"
                        class="form-control vti_tunnel_ip"
                        placeholder="Example : 192.168.20.0/24"
                        @keyup="setErrors($event)"
                      />
                      <div class="help text-danger">
                        {{ VTIErrors["vti_tunnel_ip"] }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Remote Tunnel IP</label>
                      <input
                        type="text"
                        id="vti_remote_tunnel_ip"
                        name="vti_remote_tunnel_ip"
                        v-bind:class="{
                          'has-error': errors.has('vti_remote_tunnel_ip'),
                        }"
                        v-model="value.vti_remote_tunnel_ip"
                        class="form-control vti_remote_tunnel_ip"
                        placeholder="Example : 192.168.20.1"
                        @keyup="setErrors($event)"
                      />
                      <div class="help text-danger">
                        {{ VTIErrors["vti_remote_tunnel_ip"] }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="control-label">MTU</label>
                      <input
                        type="text"
                        id="vti_mtu"
                        name="vti_mtu"
                        v-bind:class="{ 'has-error': errors.has('vti_mtu') }"
                        v-model="value.vti_mtu"
                        class="form-control vti_mtu"
                        placeholder="Example : 1500"
                      />
                      <div class="help text-danger" v-show="errors.has('vti_mtu')">
                        {{ errors.first("vti_mtu") }}
                      </div>
                    </div>
                  </div>

                  <div v-if="value.interface_type !== 'SITETOSITE'" class="form-group">
                    <label class="control-label">IPSEC Encryption</label>
                    <div class="d-flex align-items-center mt-1">
                      <label class="radio mr-3">
                        <input
                          type="radio"
                          id="ipsec_encryption"
                          name="ipsec_encryption"
                          @click="updateIpsecEncryption('1')"
                          v-model="value.ipsec_encryption"
                          class="ipsec_encryption"
                          value="1"
                        />
                        <span class="radio-mark"></span>
                        Yes
                      </label>
                      <label class="radio">
                        <input
                          type="radio"
                          id="ipsec_encryption"
                          name="ipsec_encryption"
                          @click="updateIpsecEncryption('0')"
                          v-model="value.ipsec_encryption"
                          class="ipsec_encryption"
                          value="0"
                        />
                        <span class="radio-mark"></span>
                        No
                      </label>
                    </div>
                    <div class="help text-danger" v-show="errors.has('ipsec_encryption')">
                      {{ errors.first("ipsec_encryption") }}
                    </div>
                  </div>

                  <div v-if="value.interface_type === 'SITETOSITE'">
                    <div v-if="is_edit" class="form-group">
                      <label class="control-label">Status</label>
                      <multiselect
                        v-model="value.tunnel_status"
                        :options="Object.keys(pre.tunnelStatus)"
                        :custom-label="(opt) => pre.tunnelStatus[opt]"
                        :searchable="false"
                        :multiple="false"
                        id="tunnel_status"
                        v-bind:class="{
                          'has-error': errors.has('tunnel_status'),
                        }"
                        v-validate="'required'"
                        name="tunnel_status"
                      >
                      </multiselect>
                    </div>

                    <div class="form-group">
                      <label class="control-label">Name</label>
                      <input
                        type="text"
                        id="sitetosite_name"
                        name="sitetosite_name"
                        v-model="value.sitetosite_name"
                        class="form-control sitetosite_name"
                        placeholder="Name"
                      />
                    </div>

                    <div class="form-group">
                      <label class="control-label">Description</label>
                      <input
                        type="text"
                        id="sitetosite_description"
                        name="sitetosite_description"
                        v-model="value.sitetosite_description"
                        class="form-control sitetosite_description"
                        placeholder="Description"
                      />
                    </div>

                    <div class="form-group">
                      <label class="control-label">Remote Gateway</label>
                      <div class="d-flex align-items-center mt-1">
                        <label class="radio mr-3">
                          <input
                            type="radio"
                            id="remoteGateway"
                            name="remoteGateway"
                            v-model="value.remoteGateway"
                            class=""
                            value="any"
                          />
                          <span class="radio-mark"></span>
                          Any
                        </label>
                        <label class="radio">
                          <input
                            type="radio"
                            id="remoteGateway"
                            name="remoteGateway"
                            v-model="value.remoteGateway"
                            class=""
                            value="ip"
                          />
                          <span class="radio-mark"></span>
                          IP
                        </label>
                      </div>
                      <div class="help text-danger" v-show="errors.has('remoteGateway')">
                        {{ errors.first("remoteGateway") }}
                      </div>
                    </div>

                    <div v-if="value.remoteGateway == 'ip'" class="form-group">
                      <label class="control-label">IP Address</label>
                      <input
                        type="text"
                        id="remoteGatewayIP"
                        name="remoteGatewayIP"
                        v-model="value.remoteGatewayIP"
                        class="form-control remoteGatewayIP"
                        placeholder="IP Address"
                      />
                    </div>

                    <!-- Reset value after change remote gateway -->

                    <div class="form-group">
                      <label class="control-label">My Identifier</label>
                      <input
                        type="text"
                        id="myIdentifierData"
                        name="myIdentifierData"
                        v-bind:class="{
                          'has-error': errors.has('myIdentifierData'),
                        }"
                        v-model="value.myIdentifierData"
                        class="form-control myIdentifierData"
                        placeholder="My Identifier"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('myIdentifierData')"
                      >
                        {{ errors.first("myIdentifierData") }}
                      </div>
                    </div>

                    <div class="form-group" style="display: none">
                      <label class="control-label">Peer Identifier</label>
                      <input
                        type="text"
                        id="peerIdentifierData"
                        name="peerIdentifierData"
                        v-bind:class="{
                          'has-error': errors.has('peerIdentifierData'),
                        }"
                        v-model="value.peerIdentifierData"
                        class="form-control peerIdentifierData"
                        placeholder="Peer Identifier"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('peerIdentifierData')"
                      >
                        {{ errors.first("peerIdentifierData") }}
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="
                      value.ipsec_encryption == 1 || value.interface_type === 'SITETOSITE'
                    "
                  >
                    <div
                      v-if="value.interface_type !== 'SITETOSITE'"
                      style="display: none"
                      class="form-group"
                    >
                      <label class="control-label">Profile Name</label>
                      <input
                        type="text"
                        id="ipsec_profile_name"
                        name="ipsec_profile_name"
                        v-bind:class="{
                          'has-error': errors.has('ipsec_profile_name'),
                        }"
                        v-model="value.ipsec_profile_name"
                        class="form-control ipsec_profile_name"
                        placeholder="Profile Name"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('ipsec_profile_name')"
                      >
                        {{
                          `The ipsec profile name field may only contain alpha-numeric characters`
                        }}
                      </div>
                    </div>

                    <div
                      v-if="value.interface_type !== 'SITETOSITE'"
                      style="display: none"
                      class="form-group"
                    >
                      <label class="control-label">Description</label>
                      <input
                        type="text"
                        id="ipsec_description"
                        name="ipsec_description"
                        v-bind:class="{
                          'has-error': errors.has('ipsec_description'),
                        }"
                        v-model="value.ipsec_description"
                        class="form-control ipsec_description"
                        placeholder="Description"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('ipsec_description')"
                      >
                        {{ errors.first("ipsec_description") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="control-label">Asymmetric PSK</label>
                      <div class="d-flex align-items-center mt-1">
                        <label class="radio mr-3">
                          <input
                            type="radio"
                            id="asymmetric_psk_site"
                            name="asymmetric_psk_site"
                            @click="updateAsymmetricPSK('1')"
                            v-model="value.asymmetric_psk_site"
                            class="asymmetric_psk_site"
                            value="1"
                          />
                          <span class="radio-mark"></span>
                          Yes
                        </label>
                        <label class="radio">
                          <input
                            type="radio"
                            id="asymmetric_psk_site"
                            name="asymmetric_psk_site"
                            @click="updateAsymmetricPSK('0')"
                            v-model="value.asymmetric_psk_site"
                            class="asymmetric_psk_site"
                            value="0"
                          />
                          <span class="radio-mark"></span>
                          No
                        </label>
                      </div>
                      <div
                        class="help text-danger"
                        v-show="errors.has('asymmetric_psk_site')"
                      >
                        {{ errors.first("asymmetric_psk_site") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="control-label">Remote Psk</label>
                      <input
                        type="text"
                        id="remote_psk"
                        name="remote_psk"
                        v-bind:class="{ 'has-error': errors.has('remote_psk') }"
                        v-model="value.remote_psk"
                        class="form-control remote_psk"
                        placeholder="Remote Psk"
                      />
                      <div class="help text-danger" v-show="errors.has('remote_psk')">
                        {{ errors.first("remote_psk") }}
                      </div>
                    </div>

                    <div v-if="value.asymmetric_psk_site == 1" class="form-group">
                      <label class="control-label">Local Psk</label>
                      <input
                        type="text"
                        id="local_psk"
                        name="local_psk"
                        v-bind:class="{ 'has-error': errors.has('local_psk') }"
                        v-model="value.local_psk"
                        class="form-control local_psk"
                        placeholder="Local Psk"
                      />
                      <div class="help text-danger" v-show="errors.has('local_psk')">
                        {{ errors.first("local_psk") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="control-label">Key Exchange Version</label>
                      <multiselect
                        v-model="value.sitetosite_ikev"
                        :options="Object.keys(pre.keyExchangedVersions)"
                        :custom-label="(opt) => pre.keyExchangedVersions[opt]"
                        :searchable="false"
                        :multiple="false"
                        id="sitetosite_ikev"
                        v-bind:class="{
                          'has-error': errors.has('sitetosite_ikev'),
                        }"
                        name="sitetosite_ikev"
                      >
                      </multiselect>
                    </div>

                    <div v-if="value.interface_type === 'SITETOSITE'" class="form-group">
                      <label class="control-label">Negotiation Mode</label>
                      <multiselect
                        v-model="value.negoMode"
                        :options="Object.keys(pre.negotiationMode)"
                        :custom-label="(opt) => pre.negotiationMode[opt]"
                        :searchable="false"
                        :multiple="false"
                        id="negoMode"
                        v-bind:class="{ 'has-error': errors.has('negoMode') }"
                        name="negoMode"
                      >
                      </multiselect>
                    </div>

                    <div class="form-group">
                      <label class="control-label">Load Connection</label>
                      <multiselect
                        v-model="value.loadConnection"
                        :options="Object.keys(pre.loadConnections)"
                        :custom-label="(opt) => pre.loadConnections[opt]"
                        :searchable="false"
                        :multiple="false"
                        id="loadConnection"
                        v-bind:class="{
                          'has-error': errors.has('loadConnection'),
                        }"
                        name="loadConnection"
                      >
                      </multiselect>
                    </div>

                    <h4 class="card-common-title p-0 my-3">IKE</h4>

                    <div class="form-group">
                      <label class="control-label">Algorithm</label>
                      <multiselect
                        v-model="value.ike_algorithm"
                        :options="Object.keys(pre.IKEAlgorithms)"
                        :custom-label="(opt) => pre.IKEAlgorithms[opt]"
                        :searchable="false"
                        :multiple="false"
                        id="ike_algorithm"
                        v-bind:class="{
                          'has-error': errors.has('ike_algorithm'),
                        }"
                        name="ike_algorithm"
                      >
                      </multiselect>
                    </div>

                    <div class="form-group">
                      <label class="control-label">Length</label>
                      <multiselect
                        v-model="value.ike_length"
                        :options="Object.keys(pre.IKELengths)"
                        :custom-label="(opt) => pre.IKELengths[opt]"
                        :searchable="false"
                        :multiple="false"
                        placeholder="Length"
                        id="ike_length"
                        v-bind:class="{ 'has-error': errors.has('ike_length') }"
                        name="ike_length"
                      >
                      </multiselect>
                    </div>

                    <div class="form-group">
                      <label class="control-label">Hash</label>
                      <multiselect
                        v-model="value.ike_hash"
                        :options="Object.keys(pre.IKEHashs)"
                        :custom-label="(opt) => pre.IKEHashs[opt]"
                        :searchable="false"
                        :multiple="false"
                        placeholder="Hash"
                        id="ike_hash"
                        v-bind:class="{ 'has-error': errors.has('ike_hash') }"
                        name="ike_hash"
                      >
                      </multiselect>
                    </div>

                    <div class="form-group">
                      <label class="control-label">DH Group</label>
                      <multiselect
                        v-model="value.ike_dhGroup"
                        :options="Object.keys(pre.IKEDhGroup)"
                        :custom-label="(opt) => pre.IKEDhGroup[opt]"
                        :searchable="false"
                        :multiple="false"
                        placeholder="DH Group"
                        id="ike_dhGroup"
                        v-bind:class="{
                          'has-error': errors.has('ike_dhGroup'),
                        }"
                        name="ike_dhGroup"
                      >
                      </multiselect>
                    </div>

                    <div v-if="value.interface_type === 'SITETOSITE'">
                      <h4 class="card-common-title p-0 my-3">Phase 2</h4>
                    </div>

                    <div v-if="value.interface_type === 'SITETOSITE'" class="form-group">
                      <label class="control-label">Local IP</label>
                      <input
                        type="text"
                        id="sitetosite_local_network"
                        name="sitetosite_local_network"
                        v-bind:class="{
                          'has-error': errors.has('sitetosite_local_network'),
                        }"
                        v-model="value.sitetosite_local_network"
                        class="form-control sitetosite_local_network"
                        placeholder="Example : 192.168.20.0/24,192.168.30.0/24,192.168.40.0/24"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('sitetosite_local_network')"
                      >
                        {{ errors.first("sitetosite_local_network") }}
                      </div>
                    </div>

                    <div v-if="value.interface_type === 'SITETOSITE'" class="form-group">
                      <label class="control-label">Remote IP</label>
                      <input
                        type="text"
                        id="sitetosite_remote_network"
                        name="sitetosite_remote_network"
                        v-bind:class="{
                          'has-error': errors.has('sitetosite_remote_network'),
                        }"
                        v-model="value.sitetosite_remote_network"
                        class="form-control sitetosite_remote_network"
                        placeholder="Example : 192.168.20.0/24,192.168.30.0/24,192.168.40.0/24"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('sitetosite_remote_network')"
                      >
                        {{ errors.first("sitetosite_remote_network") }}
                      </div>
                    </div>

                    <h4 class="card-common-title p-0 my-3">ESP</h4>

                    <div class="form-group">
                      <label class="control-label">Algorithm</label>
                      <multiselect
                        v-model="value.esp_algorithm"
                        :options="Object.keys(pre.IKEAlgorithms)"
                        :custom-label="(opt) => pre.IKEAlgorithms[opt]"
                        :searchable="false"
                        :multiple="false"
                        id="esp_algorithm"
                        v-bind:class="{
                          'has-error': errors.has('esp_algorithm'),
                        }"
                        name="esp_algorithm"
                      >
                      </multiselect>
                    </div>

                    <div class="form-group">
                      <label class="control-label">Length</label>
                      <multiselect
                        v-model="value.esp_length"
                        :options="Object.keys(pre.IKELengths)"
                        :custom-label="(opt) => pre.IKELengths[opt]"
                        :searchable="false"
                        :multiple="false"
                        placeholder="Length"
                        id="esp_length"
                        v-bind:class="{ 'has-error': errors.has('esp_length') }"
                        name="esp_length"
                      >
                      </multiselect>
                    </div>

                    <div class="form-group">
                      <label class="control-label">Hash</label>
                      <multiselect
                        v-model="value.esp_hash"
                        :options="Object.keys(pre.IKEHashs)"
                        :custom-label="(opt) => pre.IKEHashs[opt]"
                        :searchable="false"
                        :multiple="false"
                        placeholder="Hash"
                        id="esp_hash"
                        v-bind:class="{ 'has-error': errors.has('esp_hash') }"
                        name="esp_hash"
                      >
                      </multiselect>
                    </div>

                    <div class="form-group">
                      <label class="control-label">DH Group</label>
                      <multiselect
                        v-model="value.esp_dhGroup"
                        :options="Object.keys(pre.IKEDhGroup)"
                        :custom-label="(opt) => pre.IKEDhGroup[opt]"
                        :searchable="false"
                        :multiple="false"
                        placeholder="DH Group"
                        id="esp_dhGroup"
                        v-bind:class="{
                          'has-error': errors.has('esp_dhGroup'),
                        }"
                        name="esp_dhGroup"
                      >
                      </multiselect>
                    </div>

                    <div class="form-group">
                      <label class="control-label">Keep-Alive</label>
                      <div class="d-flex">
                        <label
                          class="radio mr-3"
                          v-for="(keepalive_type, index) in ['OFF', 'ON']"
                          :key="index"
                        >
                          <input
                            type="radio"
                            :value="index"
                            v-model="value.keepalive_type"
                            name="keepalive_type"
                            id="keepalive_type"
                          />
                          <span class="radio-mark"></span>
                          {{ keepalive_type.toUpperCase() }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import LocalStorage from "@/services/localStorage";
import { CommonAPI } from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";
// import { extend } from "vee-validate";

export default {
  name: "TunnelConfigurationForm",
  metaInfo: {
    title: "TunnelConfigurations | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    is_copy: false,
    params: {},

    value: {
      tunnel_status: "enable",
      asymmetric_psk_site: 0,
      keepalive_type: 1,
      remoteGateway: "any",
    },
    pre: {
      audraName: [],
      interfaceTypes: { GRE: "GRE", VTI: "VTI", SITETOSITE: "SITE TO SITE" },
      tunnelStatus: { enable: "ENABLE", disable: "DISABLE" },
      loadConnections: {
        add: "Add",
        start: "Start",
        route: "Route",
        ignore: "Ignore",
      },
      IKEAlgorithms: {
        aes: "AES",
        aes128gcm: "AES128-GCM",
        aes192gcm: "AES192-GCM",
        aes256: "AES256",
        blowfish: "Blowfish",
        "3des": "3DES",
        des: "DES",
        cast128: "CAST128",
      },
      IKELengths: {
        aes256: "256 bits",
        aes192: "192 bits",
        aes128: "128 bits",
      },
      IKEHashs: {
        md5: "MD5",
        sha1: "SHA1",
        sha256: "SHA256",
        sha384: "SHA384",
        sha512: "SHA512",
        aesxcbc: "AES-XCBC",
      },
      IKEDhGroup: {
        modp768: "1 (768 bit)",
        modp1024: "2 (1024 bit)",
        modp1536: "5 (1536 bit)",
        modp2048: "14 (2048 bit)",
        modp3072: "15 (3072 bit)",
        modp4096: "16 (4096 bit)",
        ecp256: "ecp256",
        ecp384: "ecp384",
      },
      keyExchangedVersions: { ikev1: "IKEv1", ikev2: "IKEv2" },
      negotiationMode: { main: "Main", aggressive: "Aggressive" },
    },
    errorsObj: {},
    GREErrors: {
      tunnel_name: "",
      description: "",
      local_ip: "",
      remote_ip: "",
      tunnel_ip: "",
      remote_tunnel_ip: "",
    },
    VTIErrors: {
      vti_name: "",
      vti_description: "",
      vti_local_ip: "",
      vti_remote_ip: "",
      vti_tunnel_ip: "",
      vti_remote_tunnel_ip: "",
    },
  }),
  methods: {
    handleSubmission() {
      const _this = this;
      if (this.validateAll()) {
        _this.is_loading = true;
        let api_url = "/tunnelconfigurations";
        let method = "POST";
        if (_this.is_edit) {
          api_url = "/tunnelconfigurations/" + _this.$route.params.id;
          method = "PUT";
        }

        axios({
          method: method,
          url: api_url,
          data: _this.value,
          headers: { "Content-Type": "application/json" },
        })
          .then(function (response) {
            _this.$toaster.success(response.data.message);
            _this.$router.push({ name: "TunnelConfigurationList" });
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              _this.$toaster.error(errors.response.data.errors.message);
              _this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              _this.$toaster.error(errors.response.data.message);
              _this.$setErrorsFromResponse(errors.response.data);
            }
          })
          .finally(() => {
            _this.is_loading = false;
          });
      }
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/tunnelconfigurations/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (
        !_.isEmpty(this.params) &&
        this.params.id !== undefined &&
        this.params.isCopy !== undefined
      ) {
        this.is_copy = true;
      } else if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit || this.is_copy) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back();
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
        this.value.ipsec_encryption = 0;
        this.value.interface_type = "GRE";
      }

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },

    validateIpCidr(value) {
      const ipAddressPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(3[0-2]|[0-2]?[0-9])$/;
      return ipAddressPattern.test(value) ? 1 : 0;
    },

    validateIp(value) {
      const ipAddressPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      return ipAddressPattern.test(value) ? 1 : 0;
    },

    validateAlphaNumericUnderscore(value) {
      const alphaNumericUnderscorePattern = /^[a-zA-Z0-9_]+$/;
      return alphaNumericUnderscorePattern.test(value) ? true : 0;
    },

    validateAlphaNumeric(value) {
      const alphaNumericUnderscorePattern = /^[a-zA-Z0-9]*$/;
      return alphaNumericUnderscorePattern.test(value) ? true : 0;
    },

    updateIpsecEncryption(newValue) {
      this.value.ipsec_encryption = newValue;
      this.$forceUpdate();
    },
    updateTunnelType(type) {
      if (type == "VTI") {
        this.value.ipsec_encryption = 1;
      } else {
        this.value.ipsec_encryption = 0;
      }

      this.value.interface_type = type;
      this.initializeErrors(type);
      this.$forceUpdate();
    },

    updateAsymmetricPSK(newValue) {
      if (this.value.interface_type == "SITETOSITE") {
        this.value.asymmetric_psk_site = newValue;
      } else {
        this.value.asymmetric_psk = newValue;
      }
      this.$forceUpdate();
    },

    validateAll() {
      let validate = true;
      if (this.value.interface_type == "GRE") {
        const GREErrorsKeys = Object.keys(this.GREErrors);
        for (let i = 0; i < GREErrorsKeys.length; i++) {
          if (this.GREErrors[GREErrorsKeys[i]] != "") validate = false;
          else if (!this.value[GREErrorsKeys[i]]) {
            validate = false;
            this.GREErrors[GREErrorsKeys[i]] = "This field is required!";
          }
        }
      } else if (this.value.interface_type == "VTI") {
        const VTIErrorsKeys = Object.keys(this.VTIErrors);
        for (let i = 0; i < VTIErrorsKeys.length; i++) {
          if (this.VTIErrors[VTIErrorsKeys[i]] != "") validate = false;
          else if (!this.value[VTIErrorsKeys[i]]) {
            validate = false;
            this.VTIErrors[VTIErrorsKeys[i]] = "This field is required!";
          }
        }
      }

      return validate;
    },

    setErrors(event) {
      const field = event.target.name;
      if (this.value.interface_type == "GRE") {
        if (field == "local_ip" || field == "remote_ip" || field == "remote_tunnel_ip") {
          if (!this.value[field]) {
            this.GREErrors[field] = "This field is required!";
          } else if (!this.validateIp(this.value[field])) {
            this.GREErrors[field] =
              "The input format is invalid. Valid Format : 192.168.20.0";
          } else {
            this.GREErrors[field] = "";
          }
        } else if (field == "tunnel_name") {
          if (!this.value[field]) {
            this.GREErrors[field] = "This field is required!";
          } else if (this.value[field].length > 10) {
            this.GREErrors[field] = "Name must not exceed 10 characters.";
          } else if (!this.validateAlphaNumeric(this.value[field])) {
            this.GREErrors[field] =
              "The input must contain only alphanumeric characters.";
          } else {
            this.GREErrors[field] = "";
          }
        } else if (field == "description") {
          if (!this.value[field]) {
            this.GREErrors[field] = "This field is required!";
          } else {
            this.GREErrors[field] = "";
          }
        } else if (field == "tunnel_ip") {
          if (!this.value[field]) {
            this.GREErrors[field] = "This field is required!";
          } else if (!this.validateIpCidr(this.value[field])) {
            this.GREErrors[field] =
              "The input format is invalid. Valid Format : 192.168.20.0/24";
          } else {
            this.GREErrors[field] = "";
          }
        }
      } else if (this.value.interface_type == "VTI") {
        if (field == "vti_name" || field == "vti_description") {
          if (!this.value[field]) {
            this.VTIErrors[field] = "This field is required!";
          } else if (field == "vti_name" && this.value[field].length > 10) {
            this.VTIErrors[field] = "Name must not exceed 10 characters.";
          } else {
            this.VTIErrors[field] = "";
          }
        } else if (
          field == "vti_local_ip" ||
          field == "vti_remote_ip" ||
          field == "vti_remote_tunnel_ip"
        ) {
          if (!this.value[field]) {
            this.VTIErrors[field] = "This field is required!";
          } else if (!this.validateIp(this.value[field])) {
            this.VTIErrors[field] =
              "The input format is invalid. Valid Format : 192.168.20.0";
          } else {
            this.VTIErrors[field] = "";
          }
        } else if (field == "vti_tunnel_ip") {
          if (!this.value[field]) {
            this.VTIErrors[field] = "This field is required!";
          } else if (!this.validateIpCidr(this.value[field])) {
            this.VTIErrors[field] =
              "The input format is invalid. Valid Format : 192.168.20.0/24";
          } else {
            this.VTIErrors[field] = "";
          }
        }
      }
    },

    initializeErrors(type) {
      if (type != "GRE") {
        this.GREErrors = {
          tunnel_name: "",
          description: "",
          local_ip: "",
          remote_ip: "",
          tunnel_ip: "",
          remote_tunnel_ip: "",
        };
      }

      if (type != "VTI") {
        this.VTIErrors = {
          vti_name: "",
          vti_description: "",
          vti_local_ip: "",
          vti_remote_ip: "",
          vti_tunnel_ip: "",
          vti_remote_tunnel_ip: "",
        };
      }
    },
  },
  mounted() {
    this.initialize();
  },
  created() {
    // extend("alpha_num", {
    //   validate: (value) => /^[a-zA-Z0-9]+$/.test(value),
    //   message: "This field must be alphanumeric",
    // });
  },
};
</script>
